import React from 'react';
import { useTranslation } from 'react-i18next';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import SearchIcon from '../../../Icons/24x24/Search';
import Input from '../../../Input';
var UserInput = function (_a) {
    var value = _a.value, onChange = _a.onChange, className = _a.className, ariaAutocomplete = _a["aria-autocomplete"], ariaActiveDescendant = _a["aria-activedescendant"], ariaControls = _a["aria-controls"];
    var t = useTranslation().t;
    return (React.createElement(Input, { value: value, onChange: onChange, className: className, placeholder: t('deviantList.input.filter.placeholder'), withFilledBackground: true, prefixIcon: SearchIcon, "aria-autocomplete": ariaAutocomplete, "aria-activedescendant": ariaActiveDescendant, "aria-controls": ariaControls, biData: {
            evid: BiEventType.WATCH_FILTER_SEARCH_ICON_CLICK,
        } }));
};
UserInput.displayName = 'UserInput';
export default UserInput;
//# sourceMappingURL=UserInput.js.map